import React from 'react';
import { Typography, Tabs } from 'antd';
import { MLScoreTabs, MLScoreTexts } from './constants';

import MLPendingRequests from './MLPendingRequests';
import MLScoreHistory from './MLScoreHistory';
import SearchApp from './SearchApp';

const { Title } = Typography;

export const ML_Ques_Category_Map = {};

const MLScore = () => {
    const [searchAppId, setSearchAppId] = React.useState(null);

    const handleAppIdSearch = (appId) => {
        setSearchAppId(appId);
    };

    return (
        <div className='container'>
            <div className='ns-flex ns-flex_vertical ns-flex_centered'>
                <Title style={{ marginBottom: 'auto' }} level={2}>
                    {MLScoreTexts.mlScorePageTitle}
                </Title>
            </div>
            <Tabs
                size={'small'}
                defaultActiveKey={1}
                tabBarExtraContent={<SearchApp setAppId={handleAppIdSearch} />}
                destroyInactiveTabPane
            >
                <Tabs.TabPane tab={MLScoreTabs.pendingRequests} key={1}>
                    <MLPendingRequests searchAppId={searchAppId} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={MLScoreTabs.history} key={2}>
                    <MLScoreHistory searchAppId={searchAppId} />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
};

export default MLScore;
